import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TextTransformType, XpressDeliveryOrderDetail } from '@shared/models';
import { SharedDeliveryOrderService } from '@shared/services/shared-delivery-order.service';
import { MessageService } from 'primeng/api';

@Component({
	selector: 'booking-customer-profile-tab',
	templateUrl: './booking-customer-profile-tab.component.html',
	styleUrl: './booking-customer-profile-tab.component.scss'
})
export class BookingCustomerProfileTabComponent implements OnInit {
	@Input() deliveryOrderDetails!: XpressDeliveryOrderDetail;

	isCustomerStatisticsLoading: boolean = false;
	TextTransformType = TextTransformType;

	constructor(
		private deliveryOrderService: SharedDeliveryOrderService,
		private messageService: MessageService,
		private cdr: ChangeDetectorRef
	) {
	}

	ngOnInit(): void {
		void this.loadCustomerStatistics();
	}

	get userRatingFormatted() {
		return this.deliveryOrderDetails.UserRating.toFixed(1);
	}

	handleCustomerInfoClick(userId: number): void {
		// Handle customer info click
	}

	private async loadCustomerStatistics(): Promise<void> {
		if (!this.deliveryOrderDetails?.UserId) {
			return;
		}

		this.isCustomerStatisticsLoading = true;
		this.cdr.markForCheck();

		try {
			const data = await this.deliveryOrderService.getCustomerStatistics(
				{ UserId: this.deliveryOrderDetails.UserId },
				this.messageService
			);

			if (!data) {
				return;
			}

			if (!data.Success) {
				this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
				return;
			}

			this.deliveryOrderDetails.BookingsCount = data.BookingsCount;
			this.deliveryOrderDetails.CompletedCount = data.CompletedCount;
			this.deliveryOrderDetails.CompletedPercent = data.CompletedPercent;
			this.deliveryOrderDetails.TotalSpend = data.TotalSpend;
		} finally {
			this.isCustomerStatisticsLoading = false;
			this.cdr.markForCheck();
		}
	}
}

